export const promotions = [
  '🍏 Apple 50% Off',
  '🍌 Banana 20% Off',
  '🍍 Pineapple Free...',
  '🥥 Coconut 15% Off',
  '🍉 Watermelon 60% Off',
];
